import { admin2 } from './instance'

const baseUrl = (shopId) => `/${shopId}/linePushMessageLog`

/**
 * 取得 LINE 通知記錄列表 admin.linePushMessageLog.find
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} [params.memberId] - 會員ID
 * @param {string} [params.title] - 通知標題（模糊搜尋）
 * @param {string} [params.events] - 通知類型
 * @param {string} [params.status] - 發送狀態 (pending|success|failed)
 * @param {string} [params.createdAtStart] - 通知創建開始日期
 * @param {string} [params.createdAtEnd] - 通知創建結束日期
 * @param {number} [params.start=0] - 查詢起始
 * @param {number} [params.limit=20] - 查詢筆數
 * @returns {Promise<Array>} LINE 通知記錄列表
 */
export const GetLinePushMessageLog = async ({
  shopId,
  memberId,
  title,
  events,
  status,
  createdAtStart,
  createdAtEnd,
  start,
  limit,
}) => {
  return await admin2({
    method: 'GET',
    url: baseUrl(shopId),
    params: {
      memberId,
      title,
      events,
      status,
      createdAtStart,
      createdAtEnd,
      start,
      limit,
    },
  })
}

/**
 * 查詢 LINE 通知記錄數量 admin.linePushMessageLog.count
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} [params.memberId] - 會員ID
 * @param {string} [params.title] - 通知標題（模糊搜尋）
 * @param {string} [params.events] - 通知類型
 * @param {string} [params.status] - 發送狀態 (pending|success|failed)
 * @param {string} [params.createdAtStart] - 通知創建開始日期
 * @param {string} [params.createdAtEnd] - 通知創建結束日期
 * @returns {Promise<Object>} { count: number }
 */
export const GetLinePushMessageLogCount = async ({
  shopId,
  memberId,
  title,
  events,
  status,
  createdAtStart,
  createdAtEnd,
}) => {
  return await admin2({
    method: 'GET',
    url: `${baseUrl(shopId)}/count`,
    params: {
      memberId,
      title,
      events,
      status,
      createdAtStart,
      createdAtEnd,
    },
  })
}

/**
 * 取得單筆 LINE 通知記錄詳情 admin.linePushMessageLog.findOne
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.id - 通知記錄ID
 * @returns {Promise<Object>} LINE 通知記錄詳情
 */
export const FindLinePushMessageLog = async ({ shopId, id }) => {
  return await admin2({
    method: 'GET',
    url: `${baseUrl(shopId)}/${id}`,
  })
}

/**
 * 取得 LINE 通知統計資訊 admin.linePushMessageLog.getStatistics
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} [params.memberId] - 會員ID
 * @param {string} [params.title] - 通知標題（模糊搜尋）
 * @param {string} [params.events] - 通知類型
 * @param {string} [params.status] - 發送狀態 (pending|success|failed)
 * @param {string} [params.createdAtStart] - 通知創建開始日期
 * @param {string} [params.createdAtEnd] - 通知創建結束日期
 * @returns {Promise<Object>} 統計資訊
 * @returns {number} totalCount - 總通知數
 * @returns {number} successCount - 成功通知數
 * @returns {number} failedCount - 失敗通知數
 * @returns {number} pendingCount - 待發送通知數
 * @returns {number} lineMessageCount - LINE 訊息則數總計
 */
export const GetLinePushMessageLogStatistics = async ({
  shopId,
  memberId,
  title,
  events,
  status,
  createdAtStart,
  createdAtEnd,
}) => {
  return await admin2({
    method: 'GET',
    url: `${baseUrl(shopId)}/statistics`,
    params: {
      memberId,
      title,
      events,
      status,
      createdAtStart,
      createdAtEnd,
    },
  })
}

/**
 * 取得 LINE 通知事件類型列表 admin.linePushMessageLog.getEventTypes
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @returns {Promise<Array>} 事件類型列表
 * @example
 * // 回傳格式
 * [{
 *   event: {
 *     key: ['appointmentOpen', 'appointmentCreate'],
 *     displayName: '預約建立'
 *   },
 *   eventType: {
 *     key: 'appointment',
 *     displayName: '預約通知'
 *   }
 * }]
 */
export const GetLinePushEventTypes = async ({ shopId }) => {
  return await admin2({
    method: 'GET',
    url: `${baseUrl(shopId)}/eventTypes`,
  })
}
